import { render } from "./AssingResources.vue?vue&type=template&id=55d57d3c&scoped=true"
import script from "./AssingResources.vue?vue&type=script&lang=js"
export * from "./AssingResources.vue?vue&type=script&lang=js"

import "./AssingResources.vue?vue&type=style&index=0&id=55d57d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d57d3c"]])

export default __exports__